<template>
  <div class="alert-wrapper">
    <v-alert
      v-if="activeSubscription && subscriptionAccessType === 'LIMITED'"
      density="compact"
      class="alert"
    >
      <div class="d-flex align-center ga-2">
        <v-icon size="large">$warning</v-icon>
        <span v-if="activeSubscription?.lastSubscriptionDetails?.clientSecret">
          Your current subscription is past due because your latest payment requires authentication.
          To continue using Continuum Design with full access, please
          <RouterLink to="/subscription/my-plan">
            authenticate the payment.
          </RouterLink>
        </span>
        <span v-else-if="isRecoverableState" class="d-flex flex-wrap ga-1">
          <template v-if="isSubscriptionAdmin">
            Your last payment failed, so your subscription is not active and your access is read-only — your projects and workflows are safe.
            <template v-if="pastDueNextAttempt">We'll retry on {{ pastDueNextAttempt }}.</template>
            <RouterLink to="/subscription/billing/manage-billing">Update your payment method</RouterLink>
            or
            <RouterLink to="/subscription/my-plan">cancel your plan</RouterLink>
            to stop further charges.
          </template>
          <template v-else>
            Your subscription is not active because a payment failed, so your access is read-only — your projects and workflows are safe.
            You can contact your subscription admin, or you can
            <RouterLink to="/subscription/my-plan">start your own subscription</RouterLink>
            to continue using Qlerify.
          </template>
        </span>
        <span v-else class="d-flex ga-1">
          You don't have an active subscription, so your access is read-only — your projects and workflows are safe.
          To continue editing, please
          <template v-if="isSubscriptionAdmin">
            <RouterLink v-if="hasCardOnFile" to="/subscription/my-plan">renew your plan.</RouterLink>
            <RouterLink v-else to="/subscription/billing/manage-billing">add a payment method.</RouterLink>
          </template>
          <RouterLink v-else to="/subscription/my-plan">start your own subscription.</RouterLink>
        </span>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import format from 'date-fns/format'
import { hasCardOnFile, isRecoverableState } from '@/utils/payments'

export default {
  computed: {
    ...mapState({
      userId: state => state.userId,
      currentUser: state => state.user.user,
      activeSubscription: (state) => state.payments.activeSubscription,
      subscriptionAccessType: (state) => state.payments.subscriptionAccessType,
      subscriptionState: (state) => state.payments.subscriptionState,
      isSubscriptionAdmin: state => state.payments.isSubscriptionAdmin
    }),
    isRecoverableState () {
      return isRecoverableState(this.subscriptionState)
    },
    hasCardOnFile () {
      return hasCardOnFile(this.activeSubscription)
    },
    pastDueNextAttempt () {
      const nextAttempt = this.activeSubscription?.lastSubscriptionDetails?.latestInvoice?.nextPaymentAttempt
      if (nextAttempt) {
        return format(new Date(nextAttempt), 'MMMM dd, yyyy')
      }

      return ''
    },
    nextBillingDate () {
      const nextBillingDate = this.activeSubscription?.subscriptionDetails?.nextBillingDate
      if (nextBillingDate) {
        return new Date(nextBillingDate)
      }
      return null
    }
  }
}
</script>

<style scoped>
.alert-wrapper {
  width: 100vw;
  margin-left: -40px;
}

.alert {
  font-size: 14px;
  border-radius: 0;
  background-color: #73E5A6;
}

[data-theme="dark"] .alert,
[data-theme="dark"] .alert :deep(.v-alert__content),
[data-theme="dark"] .alert :deep(.v-icon),
[data-theme="dark"] .alert :deep(a) {
  color: #1C1F1D !important;
}
</style>
